const BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

let _token = null;
export function setToken(t) { _token = t; }

async function request(method, path, body) {
  const headers = { "Content-Type": "application/json" };
  if (_token) headers["Authorization"] = `Bearer ${_token}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers, body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!data.ok) throw new Error(data.error || "Errore sconosciuto");
  return data.data;
}

async function download(path) {
  const headers = {};
  if (_token) headers["Authorization"] = `Bearer ${_token}`;
  const res = await fetch(`${BASE}${path}`, { headers });
  if (!res.ok) throw new Error("Errore download");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = res.headers.get("content-disposition")?.split("filename=")[1]?.replace(/"/g, "") || "export.xlsx";
  a.click();
  URL.revokeObjectURL(url);
}

// Download PDF autenticato
async function downloadPdf(id, protocollo) {
  const headers = {};
  if (_token) headers["Authorization"] = `Bearer ${_token}`;
  const res = await fetch(`${BASE}/preventivi/${id}/pdf`, { headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Errore download PDF");
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Preventivo_${protocollo || id}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const api = {
  // Auth
  login:           (email, password) => request("POST", "/auth/login", { email, password }),
  me:              ()                => request("GET",  "/auth/me"),
  changePassword:  (v, n)            => request("POST", "/auth/change-password", { vecchia_password: v, nuova_password: n }),

  // Profilo
  getProfilo:      ()     => request("GET",   "/utenti/profilo"),
  aggiornaProfilo: (body) => request("PATCH", "/utenti/profilo", body),

  // Preventivi
  lista:           (params = {}) => { const qs = new URLSearchParams(params).toString(); return request("GET", `/preventivi${qs ? "?" + qs : ""}`); },
  dettaglio:       (id)          => request("GET",    `/preventivi/${id}`),
  crea:            (body)        => request("POST",   "/preventivi", body),
  duplica:         (id)          => request("POST",   `/preventivi/${id}/duplica`),
  aggiornaStato:   (id, stato, nota) => request("PATCH", `/preventivi/${id}/stato`, { stato, nota }),
  elimina:         (id)          => request("DELETE", `/preventivi/${id}`),
  downloadPdf:     (id, protocollo) => downloadPdf(id, protocollo),

  // Utenti
  utenti:          ()            => request("GET",    "/utenti"),
  creaUtente:      (body)        => request("POST",   "/utenti", body),
  modificaUtente:  (id, body)    => request("PATCH",  `/utenti/${id}`, body),
  eliminaUtente:   (id)          => request("DELETE", `/utenti/${id}`),

  // Clienti
  cercaClienti:    (q, tipo) => { const qs = new URLSearchParams({ q, ...(tipo ? { tipo } : {}) }).toString(); return request("GET", `/clienti?${qs}`); },

  // Approvazioni
  approvPendenti:  ()                    => request("GET",  "/approvazioni/pendenti"),
  richiediApprov:  (id)                  => request("POST", `/approvazioni/richiedi/${id}`),
  decidiApprov:    (id, esito, nota)     => request("POST", `/approvazioni/${id}/decidi`, { esito, nota }),

  // Dashboard
  getDashboard:    (anno)                => request("GET", `/dashboard?anno=${anno}`),

  // Export
  exportExcel:     (params = {}) => { const qs = new URLSearchParams(params).toString(); return download(`/export/preventivi${qs ? "?" + qs : ""}`); },

  // Impostazioni
  getImpostazioni: ()     => request("GET",   "/impostazioni"),
  setImpostazioni: (body) => request("PATCH", "/impostazioni", body),
  getLogoUrl:      ()     => `${BASE}/impostazioni/logo`,
  uploadLogo:      (file) => {
    const headers = {};
    if (_token) headers["Authorization"] = `Bearer ${_token}`;
    headers["Content-Type"] = file.type;
    return fetch(`${BASE}/impostazioni/logo`, { method: "POST", headers, body: file })
      .then(r => r.json()).then(d => { if (!d.ok) throw new Error(d.error); return d.data; });
  },

  // Catalogo — Categorie
  getCategorie:     ()            => request("GET",    "/catalogo/categorie"),
  creaCategoria:    (body)        => request("POST",   "/catalogo/categorie", body),
  modificaCategoria:(id, body)    => request("PATCH",  `/catalogo/categorie/${id}`, body),
  eliminaCategoria: (id)          => request("DELETE", `/catalogo/categorie/${id}`),

  // Catalogo — Servizi
  getServizi:       (params = {}) => { const qs = new URLSearchParams(params).toString(); return request("GET", `/catalogo/servizi${qs ? "?" + qs : ""}`); },
  getServiziWizard: (tipo_cliente)=> request("GET", `/catalogo/servizi/wizard?tipo_cliente=${tipo_cliente}`),
  creaServizio:     (body)        => request("POST",   "/catalogo/servizi", body),
  modificaServizio: (id, body)    => request("PATCH",  `/catalogo/servizi/${id}`, body),
  eliminaServizio:  (id)          => request("DELETE", `/catalogo/servizi/${id}`),

  // Catalogo — Listino
  getListino:       (servizioId)             => request("GET", `/catalogo/listino/${servizioId}`),
  salvaListino:     (servizioId, tipo, body) => request("PUT", `/catalogo/listino/${servizioId}/${tipo}`, body),

  // Promozioni
  getPromozioni:        (params = {}) => { const qs = new URLSearchParams(params).toString(); return request("GET", `/promozioni${qs ? "?" + qs : ""}`); },
  getPromoDisponibili:  (tipo_cliente, servizi_ids) => request("GET", `/promozioni/disponibili?tipo_cliente=${tipo_cliente}&servizi_ids=${servizi_ids.join(",")}`),
  creaPromozione:       (body)        => request("POST",   "/promozioni", body),
  modificaPromozione:   (id, body)    => request("PATCH",  `/promozioni/${id}`, body),
  eliminaPromozione:    (id)          => request("DELETE", `/promozioni/${id}`),
};
